<template>
  <div>
    <div class="bg-white">
      <Nav></Nav>
    </div>
    <div class="error-wrap">
      <img style="width: 100%;" src="../../assets/img/official/404.png" alt="">
        <div class="error-box">
          <div class="error-div">
            <div class="error-content">找不到您要的网页</div>
            <div class="error-tip">请刷新，或检查网络连接</div>
            <div><span class="error-refresh" @click="refresh">刷新</span></div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import Nav from '@/components/Nav.vue'
export default {
  name: "Error",
  components: {
    Nav
  },
  methods:{
    refresh: function(){
      //this.$router.go(0)
      this.$router.push({
         path: "/"
      })
    }
  }
}
</script>
<style>
.bg-white {
  background-color: #fff;
}
.error-wrap{
  width:100%;
  height: calc(100% - 80px);
}
.error-wrap .error-box{
  position: absolute;
  top:0;
  left:0;
  bottom:0;
  right:0;
  width:50%;
  height: 50%;
  margin:auto;
  text-align: center;
}
.error-wrap .error-box .error-div{
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}
.error-wrap .error-box .error-div .error-content{
  font-size: 30px;
  color: #222222;
}
.error-wrap .error-box .error-div .error-tip{
  font-size: 16px;
  color: #666666;
  padding: 10px 0 20px 0;
}
.error-wrap .error-box .error-div .error-refresh{
  background: #FF8622;
  border-radius: 2px;
  font-size: 14px;
  color: #FFFFFF;
  padding: 6px 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/error/Index.vue